<template>
    <svg
        width="660"
        height="440"
        viewBox="0 0 660 440"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0 145C0 138.373 5.37258 133 12 133H648C654.627 133 660 138.373 660 145V168C660 174.627 654.627 180 648 180H12C5.37257 180 0 174.627 0 168V145Z"
            fill="var(--et-colors-card-background)"
        />
        <path
            d="M12 188.5H648C654.351 188.5 659.5 193.649 659.5 200V223C659.5 229.351 654.351 234.5 648 234.5H12C5.64871 234.5 0.5 229.351 0.5 223V200C0.5 193.649 5.64873 188.5 12 188.5Z"
            fill="var(--et-colors-card-background)"
        />
        <path
            d="M0 255C0 248.373 5.37258 243 12 243H648C654.627 243 660 248.373 660 255V278C660 284.627 654.627 290 648 290H12C5.37257 290 0 284.627 0 278V255Z"
            fill="var(--et-colors-card-background)"
        />
        <path
            d="M0 310C0 303.373 5.37258 298 12 298H648C654.627 298 660 303.373 660 310V333C660 339.627 654.627 345 648 345H12C5.37257 345 0 339.627 0 333V310Z"
            fill="var(--et-colors-card-background)"
        />
        <path
            d="M0 365C0 358.373 5.37258 353 12 353H648C654.627 353 660 358.373 660 365V388C660 394.627 654.627 400 648 400H12C5.37257 400 0 394.627 0 388V365Z"
            fill="var(--et-colors-card-background)"
        />
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="36"
            font-weight="600"
            letter-spacing="-1px"
        >
            <tspan x="276.676" y="58.2001">Pricing</tspan>
        </text>
        <text
            fill="#475467"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="16"
            letter-spacing="0em"
        >
            <tspan x="228.398" y="90.2001">Choose best option for you.</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="315.943" y="160.4">Base</tspan>
        </text>
        <path
            d="M12 188.5H648C654.351 188.5 659.5 193.649 659.5 200V223C659.5 229.351 654.351 234.5 648 234.5H12C5.64871 234.5 0.5 229.351 0.5 223V200C0.5 193.649 5.64873 188.5 12 188.5Z"
            stroke="var(--et-colors-brand)"
        />
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="304.494" y="215.4">Standard</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="305.35" y="270.4">Premium</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="320.467" y="325.4">VIP</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="301.383" y="380.4">Enterprise</tspan>
        </text>
    </svg>
</template>
